
import {
  stringFormat, getURLParameter, setVCode, verityInput,
} from '@/utils/util-extent';


const { $ } = window;

// eslint-disable-next-line no-extend-native
String.prototype.format = stringFormat;

const reCallItemHtml = `<li class="links-item">
<a href="javascript:;" class="links-link" data-src="/owner_news_detail.aspx?id={NEWID}&recall={RECALL}">
    <span  class="links-label">
        <span class="badge badge-pill {STYLE} mr-2">{DONE}</span>
        {DESC}</span>
    <span class="links-icon">
        <i class="icon icon-arrow"></i>
    </span>
</a>
</li>`;
const styleDone = 'badge-outline-secondary';
const styleRECALL = 'badge-secondary';

let moreItemHtml = '';

/**
 *
 * @param {*} msg 顯示回傳訊息，空值>關閉
 */
function titleRecall(msg = '') {
  if (msg !== '') {
    $('#noneRecall').show();
    $('#noneRecall small').text(msg);
  } else {
    $('#noneRecall').hide();
  }
}

function updateVCode(isSetFocus = false) {
  $('#recaptcha').val('');
  setVCode($('#recaptchaImg'));
  if (isSetFocus) $('#recaptcha').focus();
}


function initAPIData(result) {
  let listhtml = '';
  moreItemHtml = '';
  let index = 0;
  result.forEach((item) => {
    const dataItem = item;
    // 初始化三筆
    // showAllbtn 展開全才顯示剩下並隱藏
    if (item.RECALL.toUpperCase() === 'Y') {
      dataItem.STYLE = styleRECALL;
    } else {
      dataItem.STYLE = styleDone;
    }
    if (index >= 3) {
      moreItemHtml += reCallItemHtml.format(dataItem);
      $('#showAllbtn').show();
    } else {
      listhtml += reCallItemHtml.format(dataItem);
    }
    index += 1;
  });
  $('.select-block .links-list').html(listhtml);
}

function searchApi(licsno, vcode) {
  $('.select-block .links-list').html('');
  $('.offers-loading').show();
  $.ajax({
    url: '/api/owner_news_recall.ashx',
    type: 'POST',
    dataType: 'json',
    data: { licsno, vcode },
    success: (result) => {
      updateVCode();
      if (result.ReturnCode === '9999') {
        titleRecall(result.ReturnMsg);
      } else {
        initAPIData(result);
        titleRecall();
      }
    },
  }).fail((e) => {
    console.log('error', e);
    updateVCode();
    titleRecall('查無此車牌號碼，請洽TOYOTA顧客服務中心((02) 5599-7299)');
  }).always(() => {
    $('.offers-loading').hide();
  });
  $('.select-block .pop-up a.remove').removeClass('disabled');
}

function clearResult() {
  $('.select-block .links-list').html('');
  titleRecall();
  $('.select-block .pop-up a.remove').addClass('disabled');
  $('#platNumber').val('');
  updateVCode();
}

function checkVCode() {
  searchApi($('#platNumber').val(), $('#recaptcha').val());
  // console.log('圖形驗證');
  // $.ajax({
  //   url: 'api/vcode_vaild.ashx',
  //   type: 'POST',
  //   dataType: 'json',
  //   cache: 'false',
  //   data: {
  //     vcode: $('#recaptcha').val(),
  //   },
  // })
  //   .done((e) => {
  //     if (e.RS === 'OK') {
  //       // console.log('圖形驗證OK');
  //       searchApi($('#platNumber').val(), $('#recaptcha').val());
  //       updateVCode();
  //     } else {
  //       titleRecall(e.RS);
  //     }
  //   })
  //   .fail((e) => {
  //     console.log('error', e);
  //     titleRecall('伺服器忙碌中，請稍候重試。謝謝！');
  //   });
}


export function init() {
  const menuClass = '.offers-filter';
  const filterBtn = $(`${menuClass} .scroll-menu [data-btn]`);
  updateVCode();
  filterBtn.on('click', (e) => {
    const btn = $(e.target).attr('data-btn');
    $(e.target).toggleClass('active');
    $(`${menuClass} .pop-up[data-pop]`).not(`.pop-up[data-pop=${btn}]`).hide();
    filterBtn.not(`.scroll-menu [data-btn=${btn}]`).removeClass('active');
    $(`${menuClass} .pop-up[data-pop=${btn}]`).fadeToggle(300);
  });

  $('.select-block .pop-up a.remove').click(() => {
    setTimeout(() => {
      clearResult();
    }, 100);
  });

  $('.select-block .save').click(() => {
    let err = '';
    if ($('#platNumber').val() === '') err += '車牌號碼欄位尚未填寫，請再次確認！\r';
    if ($('#recaptcha').val() === '') err += '驗證碼欄位尚未填寫，請再次確認！\r';
    else if (verityInput($('#recaptcha').val(), 'num') === false) err += '驗證碼，請輸入數字！\r';

    if (err === '') {
      setTimeout(() => {
        checkVCode();
      }, 100);
    } else {
      titleRecall(err);
    }
  });

  $('#news-type-service').on('click', () => {
    $('#unit-1').fadeIn(500);
    $('#unit-2').hide();
    filterBtn.hide();
    filterBtn.removeClass('active');
    $(`${menuClass} .pop-up[data-pop]`).hide();
  });
  $('#news-type-recall').on('click', () => {
    $('#unit-1').hide();
    $('#unit-2').fadeIn(500);
    filterBtn.show();
  });

  $('#showAllbtn').on('click', () => {
    $('.select-block .links-list').append(moreItemHtml);
    $('#showAllbtn').hide();
  });

  $('.links-list').on('click', '.links-link', function event() {
    window.open($(this).data('src'), '_blank');
  });

  $('#recaptcha-reload').click(() => {
    setTimeout(() => {
      updateVCode();
    }, 100);
  });

  const typ = getURLParameter('typ');
  if (typ === '2') {
    $('#news-type-recall').trigger('click');
  }
}


export default {
  init,
};
